import React, { useEffect, useState } from 'react'

import { Breadcrumb, PageTitle, Pagination, Template } from '@components'
import Button from '@components/Button'
import Divider from '@components/Divider'
import EmptyRow from '@components/EmptyRow'
import Flex from '@components/Flex'
import Spinner from '@components/Spinner'
import Table from '@components/Table'
import Td from '@components/Td'
import Tr from '@components/Tr'
import {
	PushNotification,
	pushNotificationsApi,
} from '@services/PushNotificationsApi'
import { openModal } from '@store/ducks/modal'
import { useAppDispatch } from '@store/hooks'
import { useQuery } from '@utils/hooks'
import dayjs from 'dayjs'

import AddPushNotification from './AddPushNotification'

const styles = {
	searchContainer: 'gap-[8px] mb-[32px] items-end flex-wrap',
	divider: 'mt-[32px] mb-[12px]',
	image: 'rounded-full max-w-[40px] max-h-[40px]',
}

function PushNotifications() {
	const pages = [{ name: 'Noticação Push', href: '#', current: true }]
	const dispatch = useAppDispatch()
	const query = useQuery()

	const pageQuery = Number(query.get('page')) || 1
	const [page, setPage] = useState(pageQuery)

	const { data, isLoading } = pushNotificationsApi.useListQuery({
		page,
	})

	useEffect(() => {
		setPage(pageQuery)
	}, [pageQuery])

	return (
		<Template>
			<Breadcrumb pages={pages} />
			<PageTitle title='Notificações Push' />
			<Flex className={styles.searchContainer}>
				<Button
					onClick={() => dispatch(openModal({ name: 'addPushNotification' }))}
				>
					Adicionar Notificação
				</Button>
			</Flex>

			{isLoading ? (
				<div className='flex justify-center'>
					<Spinner size='md' />
				</div>
			) : (
				<Table
					th={[
						{ label: 'ID' },
						{ label: 'Título' },
						{ label: 'Descrição' },
						{ label: 'Imagem' },
						{ label: 'Link' },
						{ label: 'Data do Envio' },
					]}
				>
					{data?.data?.length ? (
						data.data.map((notification: PushNotification) => (
							<Tr key={notification.id}>
								<Td>{notification.id}</Td>
								<Td>{notification.title}</Td>
								<Td>{notification.description}</Td>
								<Td>
									{notification.image_url && (
										<img
											src={notification.image_url}
											alt={notification.title}
											className={styles.image}
										/>
									)}
								</Td>
								<Td>{notification.purchase_url}</Td>
								<Td>
									{dayjs(notification.created_at).format('DD/MM/YYYY HH:mm')}
								</Td>
							</Tr>
						))
					) : (
						<EmptyRow tdAmount={4} message='Nenhuma notificação encontrada' />
					)}
				</Table>
			)}

			<Divider className={styles.divider} />
			{!!data?.data?.length && (
				<Pagination
					pageCount={data?.meta.lastPage || 0}
					maxAmount={data?.meta.total || 0}
					perPage={data?.meta.perPage || 0}
				/>
			)}

			<AddPushNotification />
		</Template>
	)
}

export default PushNotifications
